<template>
  <div class="property-filter flex-container flex-row">
    <div class="left" v-if="aggCategory && aggCategory.id">
      {{ $t('component.smartRecommend') }}<span class="emphasize-text" @click="onCategorySelected(aggCategory)">{{ aggCategory.name }}</span>{{ $t('component.filterCondition') }}
    </div>
    <div class="left" v-else>
      {{ $t('component.filter') }}:
    </div>
    <div class="right flex-item flex-item-grow flex-item-shrink flex-container flex-wrap">
      <property-filter-item
        v-for="(p,index) in properties"
        :key="index"
        class="right-item"
        :form-item="p"
        @item-changed="filter=>handleProperties(p,filter)"
      />
    </div>
  </div>
</template>
<script>
import PropertyFilterItem from './PropertyFilterItem.vue'
export default {
  name: 'PropertyFilter',
  components: { PropertyFilterItem },
  data() {
    return {
      searchPropertyFilters: []
    }
  },
  props: {
    properties: {
      type: Array
    },
    aggCategory: {
      type: Object,
      default: null
    }
  },
  computed: {
    validPropertyFilters() {
      // 处理isConfigurable类型的属性，为true只传code,为false只传guid
      return this.searchPropertyFilters.reduce((arr, f) => {
        const nf = {}
        const exceptKey = f.isConfigurable ? 'guid' : 'code'
        for (const key in f) {
          if (key !== exceptKey && key !== 'isConfigurable') {
            nf[key] = f[key]
          }
        }
        arr.push(nf)
        return arr
      }, [])
    },
  },
  methods: {
    handleProperties(property, filter) {
      const existedPropIndex = this.searchPropertyFilters.findIndex((s) => s.guid === property.guid)
      if (property.valueType === 'Number' || property.valueType === 'Int') {
        if (filter.isValid === 'EMPTY') {
          existedPropIndex !== -1 && this.searchPropertyFilters.splice(existedPropIndex, 1)
          this.$emit('property-filtered', this.validPropertyFilters)
          return
        } 
        if (filter.isValid === false) {
          return
        }  
      } 
      if (filter.isValid === false) {
        existedPropIndex !== -1 && this.searchPropertyFilters.splice(existedPropIndex, 1)
        this.$emit('property-filtered', this.validPropertyFilters)
        return
      }
      delete filter.isValid
      existedPropIndex !== -1 ? this.searchPropertyFilters.splice(existedPropIndex, 1, filter) : this.searchPropertyFilters.push(filter)
      this.$emit('property-filtered', this.validPropertyFilters)
    },
    onCategorySelected(aggCategory) {
      this.$emit('agg-category-selected', aggCategory)
    }
  }
}
</script>
<style lang='less' scoped>
.property-filter{
  .left{
    position: relative;
    flex-shrink: 0;
    margin: 0 6px 6px 0 ;
    height: 24px;
    line-height: 24px;
    color: @theme-text-dark;
    .emphasize-text{
      color: @theme-color;
      position: relative;
      display: inline-block;
      height: 24px;
      cursor: pointer;
      &::after{
        position: absolute;
        content: '';
        width: 100%;left: 0;
        bottom: 4px;
        height: 1px;background-color: @theme-color;
      }
    }
  }
  .right-item{
    color: @theme-grey-2;
    margin: 0 0 6px 12px ;
  }
}

</style>
